<template>
    <div>
        <b-card no-body>
            <div>
                <b-modal v-model="modalView" no-close-on-backdrop @close="oculta" title="Correlacion" centered>
                    <div>
                        <b-form @submit="onsubmit">

                            <template v-if="creacion">
                                <b-form-group id="input-group-1" label="Selecione Maquina*: " label-for="input-maquina">
                                    <b-form-select v-model="hydraMaquina.maquina_variedad_id" :options="opcionesMaquina" @change="getMauquienVariedad"
                                        name="input-maquina"></b-form-select>
                                </b-form-group>

                                <b-form-group id="input-group-1" label="Selecione correlacion*: " label-for="input-defecto">
                                    <b-form-select v-model="hydraMaquina.correlacion_id" :options="opcionesDefecto_cal"   @change="getDefecto"
                                        name="input-defecto"></b-form-select>
                                </b-form-group>

                                
                                <b-form-group id="input-group-1" label="Selecione Formato - Defecto*: "
                                    label-for="input-formato" required>
                                    <b-form-select v-model="hydraMaquina.formato_defecto_id" :options="opcionesFormatos_cal"
                                       name="input-formato"></b-form-select>
                                </b-form-group>



                                <b-form-group id="input-group-1" label="Selecione Evaluacion*: "
                                    label-for="input-evaluacion">
                                    <b-form-select v-model="hydraMaquina.evaluacion_id" :options="opcionesEvaluacion"
                                        name="input-evaluacion"></b-form-select>
                                </b-form-group>

                                <b-form-group id="input-group-1" label="Valor Minimo*: " label-for="input-valormin">
                                    <b-form-input id="input-valormin" type="number" step="0.01" placeholder="Ingresa valor"
                                        name="input-valormin" v-model="hydraMaquina.valor_min" required></b-form-input>
                                </b-form-group>



                                <b-form-group id="input-group-1" label="Valor Maximo*: " label-for="input-valormax">
                                    <b-form-input id="input-valormax" type="number" step="0.01" placeholder="Ingresa valor"
                                        name="input-valormax" v-model="hydraMaquina.valor_max" required></b-form-input>
                                </b-form-group>

                            </template>


                            <template>
                                <b-form-group rangeDate>
                                    <label>Fecha Inicio</label>
                                    <flat-pickr id="rangeFecha" v-model="hydraMaquina.fecha_inicio" class="form-control"
                                        :config="{
                                            dateFormat: 'Y-m-d',
                                            locale: 'es',
                                            //maxDate: new Date(),
                                            allowInput: true
                                        }" />
                                </b-form-group>
                                <b-form-group rangeDate>
                                    <label>Fecha Fin</label>
                                    <flat-pickr id="rangeFecha" v-model="hydraMaquina.fecha_fin" class="form-control"
                                        :config="{
                                            dateFormat: 'Y-m-d',
                                            locale: 'es',
                                            //maxDate: new Date(),
                                            allowInput: true
                                        }" />
                                </b-form-group>

                            </template>



                            <!--  <b-form-checkbox v-if="!creacion" v-model="activo" name="check-button" switch>
                                {{ hydraMaquina.estado == 1 ? "Activo" : "Inactivo" }}
                            </b-form-checkbox> -->
                            <b-button v-if="creacion" type="submit" variant="primary"
                                :disabled="stateProcess == 'PROCESO'">Registrar</b-button>
                            <b-button v-else type="submit" variant="success"
                                :disabled="stateProcess == 'PROCESO'">Actualizar</b-button>

                        </b-form>
                    </div>
                    <template #modal-footer>
                        <div class="w-100">

                            <div v-if="stateProcess == 'ERROR'">
                                <h4 class="float-left">ERROR: {{ message }}</h4>
                            </div>
                            <div v-else-if="stateProcess == 'FIN'">
                                <h5 align="center">{{ message }}</h5>
                            </div>
                            <div v-else-if="stateProcess == 'PROCESO'">
                                <b-progress :value="100" variant="success" striped :animated="true"></b-progress>
                                <div class="text-center">
                                    {{ creacion ? "Registrando..." : "Actualizando..." }}
                                </div>
                            </div>
                            <div v-else>

                            </div>

                        </div>
                    </template>
                </b-modal>
            </div>
        </b-card>



        <b-card no-body>
            <div style="display:block" id="listaPreebarque">




                <div class="row card-body">
                    <div class="col col-sm-12">

                        <div v-if="!state_import">
                            <b-card-body>
                                <div class="d-flex justify-content-between  flex-wrap">
                                    <!-- Registar Preembarque  -->
                                    <b-form-group label-for="filterInput" class="mb-0">
                                        <b-button variant="gradient-primary" size="sm" class="mr-1" @click="listar">
                                            <feather-icon icon="RefreshCwIcon" />
                                        </b-button>

                                        <div v-if="show" class="spinner-border text-primary" role="status"
                                            style="width: 1.3rem; height: 1.3rem;">
                                        </div>

                                        &nbsp;
                                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success"
                                            @click="validadEntrada">
                                            <feather-icon icon="PlusIcon" class="mr-50" />
                                            <span class="align-middle">Nuevo</span>
                                        </b-button>

                                        &nbsp;
                                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                                            @click="exportExcel">
                                            <feather-icon icon="PlusIcon" class="mr-50" />
                                            <span class="align-middle">Exportar</span>
                                        </b-button>
                                        &nbsp;
                                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger"
                                            @click="state_import = true">
                                            <feather-icon icon="PlusIcon" class="mr-50" />
                                            <span class="align-middle">Importar</span>
                                        </b-button>



                                    </b-form-group>
                                    <!-- filter -->
                                    <b-form-group label-for="filterInput" class="mb-0">
                                        <b-input-group size="sm">
                                            <b-form-input id="filterInput" v-model="filter" type="search"
                                                placeholder="Buscar" />
                                            <b-input-group-append>
                                                <b-button :disabled="!filter" @click="filter = ''">
                                                    Borrar
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>

                                </div>
                            </b-card-body>

                            <b-table hover responsive class="position-relative" :per-page="perPage"
                                :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
                                :filter-included-fields="filterOn" @filtered="cPaginacion" :busy="cargando"
                                :bordered="true">


                                <template #cell(accion)="data">
                                    <div class="text-nowrap">
                                        <div>
                                            <b-button size="sm" variant="success" class=""
                                                @click="validadEntradaEdit(data.item)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round"
                                                    class="feather feather-edit-3">
                                                    <path d="M12 20h9"></path>
                                                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z">
                                                    </path>
                                                </svg>
                                            </b-button>
                                            &nbsp;&nbsp;
                                            <b-button size="sm" variant="danger" class=""
                                                @click="validadEntradaDelete(data.item, 0)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round"
                                                    class="feather feather-trash-2">
                                                    <polyline points="3 6 5 6 21 6"></polyline>
                                                    <path
                                                        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                                    </path>
                                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                                </svg>
                                            </b-button>
                                        </div>



                                    </div>

                                </template>

                                <template #cell(activo)="data">
                                    <div class="text-nowrap">
                                        <div>
                                            <div v-if="data.item.estado == 1">
                                                <b-badge variant="success"
                                                    >Activo</b-badge>
                                            </div>
                                            <div v-else>
                                                <b-badge variant="danger"
                                                    >Inactivo</b-badge>
                                            </div>
                                        </div>
                                    </div>

                                </template>


                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>&nbsp;Carga...</strong>
                                    </div>
                                </template>



                            </b-table>

                            <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                                <!-- page length -->
                                <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm"
                                    label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
                                    <b-form-select id="perPageSelect2" v-model="perPage" size="sm" inline
                                        :options="pageOptions" />

                                </b-form-group>

                                <!-- pagination -->
                                <div>
                                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                                        first-number last-number prev-class="prev-item" next-class="next-item" class="mb-0">
                                        <template #prev-text>
                                            <feather-icon icon="ChevronLeftIcon" size="18" />
                                        </template>
                                        <template #next-text>
                                            <feather-icon icon="ChevronRightIcon" size="18" />
                                        </template>
                                    </b-pagination>
                                </div>
                            </b-card-body>

                        </div>


                        <div v-bind:style="{ display: state_import ? 'block' : 'none' }">

                            <div class="">
                                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2"
                                    @click="state_import = false">
                                    <feather-icon icon="ChevronLeftIcon" size="15" />
                                </b-button>
                                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="warning" class="mr-2"
                                    @click="exportarFormato">
                                    <feather-icon icon="PlusIcon" class="mr-50" />
                                    <span class="align-middle">Descargar Formato</span>
                                </b-button>

                                <input type="file" class="file-input" value="Selecionar excel"
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    name="file" id="file" @change="" ref="myFiles">


                                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="ml-2"
                                    @click="importarExcel">
                                    <feather-icon icon="PlusIcon" class="mr-50" />
                                    <span class="align-middle">Importar Excel</span>
                                </b-button>



                            </div>
                            <br />



                            <template v-if="!state_import_exel">
                                <div>
                                    <hot-table :settings="hotSettings" ref="hotf"></hot-table>
                                    <div class="mt-2 text-right">
                                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success"
                                            @click="validatDatosImportados">
                                            <feather-icon icon="PlusIcon" class="mr-50" />
                                            <span class="align-middle">Importar Datos de Tabla</span>
                                        </b-button>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div>
                                    <b-table hover responsive class="position-relative" 
                                        :items="itemsExcel" 
                                        :fields="fieldsExcel" 
                                        :per-page="perPageExcel"
                                        :current-page="currentPageExcel" 
                                        :sort-by.sync="sortByExcel"
                                        :sort-desc.sync="sortDescExcel" 
                                        :sort-direction="sortDirectionExcel" 
                                        :filter="filterExcel"
                                        :filter-included-fields="filterOnExcel"
                                         @filtered="cPaginacionExcel" 
                                         :busy="cargandoExcel"
                                        :bordered="true"
                                        
                                        >

                                        <template #cell(activo)="data">
                                            <div class="text-nowrap">
                                                <div>
                                                    <div v-if="data.item.estado == 1">
                                                        <b-badge variant="success"
                                                           >Correcto</b-badge>
                                                    </div>
                                                    <div v-else>
                                                        <b-badge variant="danger"
                                                            >Error</b-badge>
                                                    </div>
                                                </div>
                                            </div>

                                        </template>


                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>&nbsp;Carga...</strong>
                                            </div>
                                        </template>



                                    </b-table>

                                    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                                        <!-- page length -->
                                        <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm"
                                            label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
                                            <b-form-select id="perPageSelect2" v-model="perPageExcel" size="sm" inline
                                                :options="pageOptionsExcel" />

                                        </b-form-group>

                                        <!-- pagination -->
                                        <div>
                                            <b-pagination v-model="currentPageExcel" :total-rows="totalRowsExcel" :per-page="perPageExcel"
                                                first-number last-number prev-class="prev-item" next-class="next-item" class="mb-0">
                                                <template #prev-text>
                                                    <feather-icon icon="ChevronLeftIcon" size="18" />
                                                </template>
                                                <template #next-text>
                                                    <feather-icon icon="ChevronRightIcon" size="18" />
                                                </template>
                                            </b-pagination>
                                        </div>
                                    </b-card-body>

                                    <div class="mt-2 text-right">
                                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success"
                                            @click="state_import_exel=false">
                                            <feather-icon icon="PlusIcon" class="mr-50" />
                                            <span class="align-middle">Volver</span>
                                        </b-button>
                                    </div>
                                </div>
                            </template>


                        </div>


                    </div>

                </div>



            </div>



            <!--   <b-modal centered v-model="estadoModal" hide-footer hide-header size="sm">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 text-center">
                                <feather-icon icon="AlertCircleIcon" size="73em" style="color: #00cfe8;font-size: 100px" />
                            </div>
                            <div class="col-12 text-center"><b style="font-size: 22px">¿Está seguro?</b></div>
                            <br>
                            <div class="col-12">
                                <div class="text-center">¿Desea generar ETL - KSB1 Categorias?</div>
                            </div>
                        </div>

                        <br>
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center">
                                    <b-button v-b-popover="'Popover inside a modal!'" class="btn btn-danger"
                                        title="Cancelar" @click="cerrarModal">Cancelar</b-button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <b-button v-b-popover="'Popover inside a modal!'" class="btn btn-success"
                                        title="Aceptar">Aceptar</b-button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>


            </b-modal> -->



        </b-card>
    </div>
</template>

<script>

import axiosIns from '@axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Swal from '../../../libs/sweet-alerts'
import { Spanish } from "flatpickr/dist/l10n/es.js"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
//import { XLSX$Utils as xlsx } from "xlsx"

var XLSX = require("xlsx");

import { HotTable } from '@handsontable/vue';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.css';

// register Handsontable's modules
registerAllModules();


const ipValidatorRegexp = /^(?:\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b|null)$/;
const numberValidatorRegexp = /^[1-9,$]*$/;

const emailValidator = (value, callback) => {
    setTimeout(() => {
        if (/.+@.+/.test(value)) {
            callback(true);

        } else {
            callback(false);
        }
    }, 1000);
};

const numberValidator = (value, callback) => {
    setTimeout(() => {
        if (value.toString().trim().length <= 0) {
            callback(false);
        } else {
            console.log(value);

            if (/^([0-9]+\.?[0-9]{0,2})$/.test(value)) {
                let valor = parseFloat(value);
                if (valor <= 0) {
                    callback(false);
                } else {
                    callback(true);
                }

            } else {
                callback(false);
            }

        }

    }, 100);
};

const numberFloatValidator = (value, callback) => {
    setTimeout(() => {
        if (value == null || value == undefined || value.toString().trim().length <= 0) {
            callback(false);
        } else {
            console.log(value);

            if (/^-?([0-9]+\.?[0-9]{0,2})$/.test(value)) {
                let valor = parseFloat(value);
               /*  if (valor <= 0) {
                    callback(false);
                } else {
                } */
                callback(true);

            } else {
                callback(false);
            }

        }

    }, 100);
};

import {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BProgress,
    BFormCheckbox,
    BSpinner,
    BForm
} from 'bootstrap-vue'
import axios from "axios";

export default {

    components: {
        BCard,
        BTable,
        BAvatar,
        BBadge,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
        BCardBody,
        BTooltip,
        BModal,
        VBModal,
        BListGroup,
        BListGroupItem,
        BRow,
        BCol,
        vSelect,
        ToastificationContent,
        flatPickr,
        BProgress,
        BFormCheckbox,
        BSpinner,
        BForm,
        HotTable
    },
    directives: {
        'b-modal': VBModal,
        Ripple,
    },
    data() {
        return {
            perPage: 5,
            perPageExcel: 5,
            pageOptions: [5, 10, 15],
            pageOptionsExcel: [5, 10, 15],
            totalRows: 1,
            totalRowsExcel: 1,
            currentPage: 1,
            currentPageExcel: 1,
            sortBy: '',
            sortByExcel: '',
            sortDesc: false,
            sortDescExcel: false,
            sortDirection: 'asc',
            sortDirectionExcel: 'asc',
            filter: null,
            filterExcel: null,
            filterOn: [],
            filterOnExcel: [],
            estadoModal: false,
            infoModal: {
                title: '',
                boton: '',
            },
            fields: [
                {
                    key: 'accion',
                    label: 'accion',
                    sortable: true
                },
                {
                    key: 'id',
                    label: 'Codigo',
                    sortable: true
                },
                {
                    key: 'valor_min',
                    label: 'Valor minimo',
                    sortable: true
                },
                {
                    key: 'valor_max',
                    label: 'Valor Maximo',
                    sortable: true
                },
                {
                    key: 'fecha_inicio',
                    label: 'Fecha Inicio',
                    sortable: true
                },
                {
                    key: 'fecha_fin',
                    label: 'Fecha Fin',
                    sortable: true
                },
                {
                    key: 'correlacion',
                    label: 'Correlacion',
                    sortable: true
                },
                {
                    key: 'defecto',
                    label: 'Defecto',
                    sortable: true
                },
                {
                    key: 'formato',
                    label: 'Formato',
                    sortable: true
                },
                {
                    key: 'nombre_categoria_evaluacion',
                    label: 'Categoria Evaluacion',
                    sortable: true
                },
                {
                    key: 'nombre_maquina',
                    label: 'Maquina',
                    sortable: true
                },
                // {
                //     key: 'cod_society',
                //     label: 'Cod. Sociedad',
                //     sortable: true
                // },
                {
                    key: 'variedad',
                    label: 'Variedad',
                    sortable: true
                },
                {
                    key: 'cultivo',
                    label: 'Cultivo',
                    sortable: true
                },
                {
                    key: 'activo',
                    label: 'Activo',
                    sortable: true
                }
            ],
            fieldsExcel: [
             
                {
                    key: 'index',
                    label: 'N°',
                    sortable: true
                },
                // {
                //     key: 'sociedad',
                //     label: 'Sociedad',
                //     sortable: true
                // },
                {
                    key: 'valor_min',
                    label: 'Valor minimo',
                    sortable: true
                },
                {
                    key: 'valor_max',
                    label: 'Valor Maximo',
                    sortable: true
                },
                {
                    key: 'fecha_inicio',
                    label: 'Fecha Inicio',
                    sortable: true
                },
                {
                    key: 'fecha_fin',
                    label: 'Fecha Fin',
                    sortable: true
                },
                {
                    key: 'correlacion_id',
                    label: 'Correlacion Id',
                    sortable: true
                },
                {
                    key: 'formato_defecto',
                    label: 'Formato Defecto Id',
                    sortable: true
                },
                {
                    key: 'evaluacion_id',
                    label: 'Categoria Evaluacion Id',
                    sortable: true
                },
                {
                    key: 'maquina_variedad_id',
                    label: 'Maquina Id',
                    sortable: true
                },
                {
                    key: 'activo',
                    label: 'Estado',
                    sortable: true
                },
                {
                    key: 'errores',
                    label: 'Errores',
                    sortable: true
                },
            ],
            items: [],
            itemsExcel: [],
            status: [
                {
                    1: 'Activo',
                    0: 'Inactivo',
                },
                {
                    1: 'light-success',
                    0: 'light-danger',
                }
            ],
            show: false,
            rangeDate: null,
            cargando: true,
            cargandoExcel: true,
            modalView: false,
            stateClose: false,
            porcentaje: 50,
            totalCC: 100,
            creacion: true,
            stateProcess: "INICIO", // "INICIO" - "PROCESO" - "FIN" - "ERROR"
            hydraMaquina: {
                id: 0,
                valor_min: 0,
                valor_max: 0,
                fecha_inicio: "2023-01-01",
                fecha_fin: "2023-01-01",
                creado: "",
                usuario_creador: 0,
                actualizado: "",
                usuario_actualizado: 0,
                correlacion_id: 0,
                evaluacion_id: 0,
                maquina_variedad_id: 0,
                estado: 0,
                formato_defecto_id: "",
                correlacion: 0,
                defecto: 0,
                formato: 0,
                nombre_categoria_evaluacion: "",
                nombre_maquina: ""
            },
            message: "",
            listDefectos: [],
            listEvaluacion: [],
            listMaquina: [],
            opcionesDefecto: [],
            opcionesDefecto_cal: [],
            opcionesEvaluacion: [],
            opcionesMaquina: [],
            lastChange: null,
            hotSettings: {
                data: [
                    // { id: 1, valor_min: 0.0, valor_max: 4.0, fecha_inicio: "2023-01-01", fecha_fin: "2023-01-01", activo: true, correlacion_id: 7, evaluacion_id: 10, maquina_variedad_id: 1 }
                ],
                beforeChange(changes, source) {
                    for (let i = changes.length - 1; i >= 0; i--) {
                        if (changes[i][3] === 'foo') {
                            changes.splice(i, 1);
                        }
                        else if (changes[i][3] === 'nuke') {
                            return false;
                        }
                        else if ((changes[i][1] === 'name.first' || changes[i][1] === 'name.last')) {
                            if (changes[i][3] !== null) {
                                changes[i][3] = changes[i][3].charAt(0).toUpperCase() + changes[i][3].slice(1);
                            }
                        }
                    }

                    this.lastChange = changes;
                },
                afterChange(changes, source) {
                },
                colHeaders: ['Valor Minimo', 'Valor Maximo', 'Fecha Inicio', 'Fecha Fin', 'Formato Defecto', 'Correlacion ID', 'Evaluacion ID', 'Maquina Variedad'],
                height: 650,
                width: '100%',
                //colHeaders: true,
                //contextMenu: true,
                //rowHeaders: true,
                //colWidths: 200,
                rowHeaders: true,
                stretchH: 'all',
                multiColumnSorting: true,
                filters: true,
                // minSpareRows: 1,
                manualColumnResize: true,
                currentRowClassName: 'currentRow',
                contextMenu: {
                    callback(key, selection, clickEvent) {
                        console.log(key, selection, clickEvent);
                    },
                    items: {
                        row_below: { name: 'Agregar fila debajo' },
                        row_above: { name: 'Agregar fila arriba' },
                        remove_row: { name: 'Remover fila' },
                        copy: { name: 'Copiar' },
                    },
                },
                dropdownMenu: ['filter_by_condition', 'filter_by_condition2', 'filter_operators', 'filter_by_value', 'filter_action_bar', '---------', 'make_read_only', 'alignment', 'copy'],
                columns: [
                    { data: 'valor_min', type: 'numeric', validator: numberFloatValidator, allowInvalid: false },
                    { data: 'valor_max', type: 'numeric', validator: numberFloatValidator, allowInvalid: false },
                    { data: 'fecha_inicio', type: 'date', dateFormat: 'YYYY-MM-DD', correctFormat: true, className: 'htRight' },
                    { data: 'fecha_fin', type: 'date', dateFormat: 'YYYY-MM-DD', correctFormat: true, className: 'htRight' },
                    { data: 'formato_defecto', type: 'dropdown', source: [], allowInvalid: false },
                    { data: 'correlacion_id', type: 'dropdown', source: [], allowInvalid: false },
                    { data: 'evaluacion_id', type: 'dropdown', source: [], allowInvalid: false },
                    { data: 'maquina_variedad_id', type: 'dropdown', source: [], allowInvalid: false },

                ],
                licenseKey: 'non-commercial-and-evaluation',

            },
            hanstable: null,
            dataImport: [],
            state_import: false,
            state_import_exel: false,
            listFormatos: [],
            selectFormato: 0,
            opcionesFormatos: [],
            opcionesFormatos_cal: [],
            defecto_id: 0,
            cultivo_id: 0
        }
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => ({
                    text: f.label,
                    value: f.key
                }))
        },

       /*  filteredCorrelaciones() {
            return this.opcionesDefecto.filter(post => {
                //this.id_provincia="0";
                return parseInt(post.id_defecto) == parseInt(this.defecto_id);
            });
        }, */
       
        filteredCorrelaciones() {
            return this.opcionesDefecto.filter(post => {
                //this.id_provincia="0";
                return parseInt(post.id_cultivo) == parseInt(this.cultivo_id);
            });
        },

        filteredFormatoDefecto() {
            return this.opcionesFormatos.filter(post => {
                //this.id_provincia="0";
                return parseInt(post.id_defecto) == parseInt(this.defecto_id);
            });
        },


    },



    mounted() {

        this.listarDefectos();
        this.listarFormatos();
        this.listarMaquinas();
        this.listarEvaluacion();

        this.hanstable = this.$refs.hotf.hotInstance;
        let me = this;
        this.hanstable.alter('insert_row_below', 10);

        this.hanstable.updateSettings({
            beforeKeyDown(e) {
                const selection = me.hanstable.getSelected()[0];
                console.log(e.keyCode)

                if (e.keyCode === 13) {
                    e.stopImmediatePropagation();

                    me.hanstable.alter('insert_row_below', 10);
                    //me.hanstable.spliceCol(selection[1], selection[0], 1);
                    e.preventDefault();

                } else if (e.keyCode == 9) {
                    if (selection[1] == 6) {
                        e.stopImmediatePropagation();
                        me.hanstable.alter('insert_row_below', 10);
                        //me.hanstable.spliceCol(selection[1], selection[0], 0, '');
                        e.preventDefault();
                    }
                }

                me.lastChange = null;

            },
        });
        /* 
                this.hanstable.addHook('afterValidate', function (isValid, value, row, prop, source) {
                    console.log('isValid', isValid);
                    return false;
                }); */


        this.listar();





    },

    methods: {

        importarExcel() {


            const me = this

            me.cargandoExcel = true;
            
            me.itemsExcel= [];
            var user = JSON.parse(localStorage.getItem("userData"));
            
            const userID = user.id; //3

            var files = document.getElementById('file').files;
            if (files.length <= 0) {
                me.$swal.fire(
                    'Mensaje',
                    'Debe selecionar un documento',
                    'warning'
                    ).then((result) => {
                });
                return
            }
            
            const formdata = new FormData()
            formdata.append('id_usuario', userID)
            formdata.append('file', files[0])
            
            
            me.state_import_exel= true;
            
            this.$swal.fire({
                title: '¿Desea Importar Datos?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-primary ml-1',
                    cancelButton: 'btn btn-outline-danger',
                },
                buttonsStyling: false,
                preConfirm: async () => {

                    const config = {
                        method: 'post',
                        url: '/hydra/hydratolerancia-importacion-file/create/',
                        data: formdata,
                        timeout: false,
                    }

                    return axiosIns(config)
                        .then(function (response) {

                            //me.hanstable.updateData([]);
                            //me.listar();
                            //me.state_import = false;
                            //me.hanstable.alter('insert_row_below', 10);
                            
                            
                            let sms = response.data.message_user;
                            let str_status =  sms == "Error al importar"? "error" : "success";
                            let title =  sms == "Error al importar"? "Error" : "Importado";
                            
                            me.itemsExcel = response.data.data;
                            me.totalRowsExcel = me.itemsExcel.length
                            me.cargandoExcel = false;

                            if(sms != "Error al importar"){
                                me.listar();
                            }

                            return {
                                'title':title, 
                                'sms': sms,
                                'str_status': str_status
                            }



                        })
                        .catch(function (error) {
                            console.log(error);
                            me.cargandoExcel = false;

                            me.$swal.showValidationMessage(
                                `Error al importar registros`
                            )

                        });

                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal.fire(
                        result.value.title,
                        result.value.sms,
                        result.value.str_status
                    );
                }
            })

        },
        exportarFormato() {

            let itemsFormato = [{
                sociedad: "",
                valor_min: "",
                valor_max: "",
                fecha_inicio: "",
                fecha_fin: "",
                formato_defecto: "",
                correlacion_id: "",
                evaluacion_id: "",
                maquina_variedad_id: "",
            }]

            let data = XLSX.utils.json_to_sheet(itemsFormato)
            const workbook = XLSX.utils.book_new()
            const filename = 'hydra_formato'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xlsx`)
        },

        getDefecto() {

            this.hydraMaquina.formato_defecto_id = 0;

            let item = this.opcionesDefecto.filter((item) => item.value == this.hydraMaquina.correlacion_id)
            this.defecto_id = item[0].id_defecto;
            this.opcionesFormatos_cal = this.filteredFormatoDefecto;

            console.log("formato_defecto", item);
            console.log("formato_defecto", this.opcionesFormatos_cal);
        },

        getMauquienVariedad() {

            this.hydraMaquina.correlacion_id = 0;

            let item = this.opcionesMaquina.filter((item) => item.value == this.hydraMaquina.maquina_variedad_id)
            this.cultivo_id = item[0].cultivo_id;
            this.opcionesDefecto_cal = this.filteredCorrelaciones;

            console.log("formato_defecto", item);
            console.log("formato_defecto", this.opcionesDefecto_cal);
        },
        exportExcel: function () {
            let data = XLSX.utils.json_to_sheet(this.items)
            const workbook = XLSX.utils.book_new()
            const filename = 'hydra_torelancias'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xlsx`)

        },



        async validatDatosImportados() {


            this.dataImport = this.hanstable.getData();
            console.log(this.dataImport);
            console.log(this.hanstable);

            let validate = false;

            if (this.dataImport.length <= 0) {
                this.$swal.fire(
                    'Error',
                    'No hay datos para importar',
                    'error'
                );
                return;
            }

            for (let index = 0; index < this.dataImport.length; index++) {
                const element = this.dataImport[index];
                let rowState = this.validaRow(element)

                for (let i = 0; i < rowState.length; i++) {
                    if (!rowState[i]) {
                        validate = !rowState[i];
                    }
                    this.hanstable.setCellMeta(index, i, 'valid', rowState[i]);
                }

            }

            this.hanstable.render();

            if (validate) {
                this.$swal.fire(
                    'Error',
                    'Hay celdas vacias o con datos incorrectos',
                    'error'
                );
                return;
            }

            // let itemVal =  this.dataImport;
            const me = this

            this.$swal.fire({
                title: '¿Desea Importar Datos?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-primary ml-1',
                    cancelButton: 'btn btn-outline-danger',
                },
                buttonsStyling: false,
                preConfirm: async () => {


                    let user = JSON.parse(localStorage.getItem("userData"));
                    let userID = user.id;// 3

                    const config = {
                        method: 'post',
                        url: '/hydra/hydratolerancia-importacion/create/',
                        data: { 'data': me.dataImport, 'usuario': userID },
                    }

                    return axiosIns(config)
                        .then(function (response) {

                            me.hanstable.updateData([]);
                            me.listar();
                            me.state_import = false;
                            me.hanstable.alter('insert_row_below', 10);

                            let sms = response.data.message_user;
                            let str_status = "success"

                            return {
                                'sms': sms,
                                'str_status': str_status
                            }

                        })
                        .catch(function (error) {
                            console.log(error);
                            me.$swal.showValidationMessage(
                                `Error al importar registros`
                            )

                        });

                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal.fire(
                        'Importado',
                        result.value.sms,
                        result.value.str_status
                    );
                }
            })






        },

        validaRow(row) {
            let staterow = [true, true, true, true, true, true, true, true];
            let num1 = 0;
            let num2 = 0;
            let inicio = null;
            let fin = null;
            try {
                if (row[0] == null || row[0] == undefined || String(row[0]).trim().length <= 0) staterow[0] = false
                else num1 = parseFloat(row[0]);
            } catch (error) {
                staterow[0] = false;
            }

            try {
                if (row[1] == null || row[1] == undefined || String(row[1]).trim().length <= 0) staterow[1] = false
                else num2 = parseFloat(row[1]);

                if (num1 > num2) staterow[0] = false;
            } catch (error) {
                staterow[1] = false;
            }

            try {

                if (row[2] == null || row[2] == undefined || String(row[2]).trim().length < 10) staterow[2] = false
                else inicio = new Date(row[2])

                if (row[3] == null || row[3] == undefined || String(row[3]).trim().length < 10) staterow[3] = false
                else fin = new Date(row[3])

                if (inicio != null && fin != null) {
                    if (inicio > fin) {
                        staterow[2] = false;
                        staterow[3] = false;
                    }
                }
            } catch (error) {

                if (inicio == null) staterow[2] = false;
                if (fin == null) staterow[3] = false;

                if (inicio != null || fin != num1) {
                    staterow[2] = false;
                    staterow[3] = false;
                }
            }


            try {
                if (row[4] == null || row[4] == undefined || String(row[4]).trim().length <= 0) staterow[4] = false;
            } catch (error) {
                staterow[4] = false;
            }


            try {
                if (row[7] == null || row[7] == undefined || String(row[7]).trim().length <= 0){
                    staterow[7] = false;
                }
            } catch (error) {
                staterow[7] = false;
            }



            try {
                if (row[5] == null || row[5] == undefined || String(row[5]).trim().length <= 0) {
                    staterow[5] = false;
                } else {
                    if (staterow[4]) {
                        let val_formato_defecto = row[4].toString().split("-").length > 1 ? row[4].toString().split("-")[1].trim() : "";
                        let arr_corre = row[5].toString().split("-");
                        
                        let arr_defecto_corr = arr_corre.length > 1 ? arr_corre[1].toString().split(":") : []
                        let defecto_corr = arr_defecto_corr.length > 0 ? arr_defecto_corr[0].toString().trim() : ""

                        let cultivo_corr_arr = arr_corre.length > 0 ? arr_corre[0].toString().split(")") : [];
                        let cultivo_arr = cultivo_corr_arr.length > 1 ? cultivo_corr_arr[1].toString().trim(): "";


                        if (val_formato_defecto !== defecto_corr) {
                            staterow[4] = false;
                            staterow[5] = false;
                        }else{
                            
                            if (staterow[7]){
                                let maquina_arr = row[7].toString().split("-");
                                let cultivo_maquina_arr= maquina_arr.length > 0 ? maquina_arr[0].toString().split(")"): [];
                                let cultivo_maquina = cultivo_maquina_arr.length > 1 ? cultivo_maquina_arr[1].toString().trim() : "";
                                
                                if (cultivo_maquina !== cultivo_arr  ) {
                                    staterow[5] = false;
                                    staterow[7] = false;
                                }
    
                            }
                        }

                    }
                }
            } catch (error) {
                staterow[5] = false;
            }

            try {
                if (row[6] == null || row[6] == undefined || String(row[6]).trim().length <= 0) staterow[6] = false;
            } catch (error) {
                staterow[6] = false;
            }

           



            return staterow;
        },
        oculta(e) {

            if (this.stateClose) {
                e.preventDefault();

                this.$swal.fire(
                    'Proceso en curso',
                    'El Etl se esta ejecutando no se puede detener el proceso.',
                    'warning'
                );
            }
        },

        listar() {


            this.cargando = true;

            const yo = this

            const config = {
                method: 'get',
                url: '/hydra/hydratolerancias/todos/',
            }

            axiosIns(config)
                .then(function (response) {

                    console.log(response);
                    yo.items = response.data.data;
                    yo.totalRows = yo.items.length
                    yo.cargando = false;
                })
                .catch(function (error) {
                    console.log(error);
                    yo.cargando = false;
                });
        },

        async listarFormatos() {
            const config = {
                method: 'get',
                url: '/hydra/hydra-formato-defectos/activo/',
            }
            try {
                const response = await axiosIns(config);
                if (response.status == 200) {
                    this.listFormatos = response.data.data;
                }

            } catch (error) {

            }


            this.addOptionesFormatos();

        },

        addOptionesFormatos() {
            this.opcionesFormatos = this.listFormatos.map((row) => {
                return {
                    text: `${row["formato"]} - ${row["defecto"]}`, value: row["id"], id_defecto: row["defecto_id"]
                }
            });

            const columns = this.hanstable.getSettings().columns;
            columns[4].source = this.opcionesFormatos.map((row) => `${row["value"]}) ${row["text"]}`);

            this.hanstable.updateSettings({ 'columns': columns });

        },


        async listarDefectos() {
            const config = {
                method: 'get',
                url: '/hydra/hydracorrelaciones/activo/',
            }

            const response = await axiosIns(config);

            if (response.status == 200) {
                this.listDefectos = response.data.data;
            }

            this.addOptonesDefecto();

        },

        addOptonesDefecto() {
            this.opcionesDefecto = this.listDefectos.map((row) => {
                return {
                    text: `${row["cultivo"]} - ${row["nombre_defecto"]}: ${row["valor"]}`, value: row["id"], id_defecto: row["defecto_id"], id_cultivo: row["cultivo_id"]
                }
            });


            const columns = this.hanstable.getSettings().columns;
            columns[5].source = this.opcionesDefecto.map((row) => `${row["value"]}) ${row["text"]}`);

            this.hanstable.updateSettings({ 'columns': columns });

        },

        async listarEvaluacion() {
            const config = {
                method: 'get',
                url: '/hydra/hydracategoriasevaluacion/activo/',
            }

            const response = await axiosIns(config);

            if (response.status == 200) {
                this.listEvaluacion = response.data.data;
            }

            this.addOptonesEvaluacion();


        },

        addOptonesEvaluacion() {
            this.opcionesEvaluacion = this.listEvaluacion.map((row) => {
                return {
                    text: `${row["nombre_categorizacion"]}: ${row["nombre"]}`, value: row["id"]
                }
            });

            const columns = this.hanstable.getSettings().columns;
            columns[6].source = this.opcionesEvaluacion.map((row) => `${row["value"]}) ${row["text"]}`);

            this.hanstable.updateSettings({ 'columns': columns });

        },


        async listarMaquinas() {
            const config = {
                method: 'get',
                url: '/hydra/hydramaquinavariedads/activo/',
            }

            const response = await axiosIns(config);

            if (response.status == 200) {
                this.listMaquina = response.data.data;
            }

            this.addOptonesMaquinas();

        },
        addOptonesMaquinas() {
            this.opcionesMaquina = this.listMaquina.map((row) => {
                return {
                    text: `${row["cultivo"]} - ${row["variedad"]} - ${row["nombre_maquina"]}`, value: row["id"], cultivo_id: row["id_cultivo"]
                }
            });


            const columns = this.hanstable.getSettings().columns;
            columns[7].source = this.opcionesMaquina.map((row) => `${row["value"]}) ${row["text"]}`);

            this.hanstable.updateSettings({ 'columns': columns });

        },





        validadEntrada() {

            this.modalView = true;
            this.creacion = true;
            this.stateProcess = "INICIO"
            this.activo = true;
            this.hydraMaquina = {
                id: 0,
                valor_min: 0,
                valor_max: 0,
                fecha_inicio: "2023-01-01",
                fecha_fin: "2023-01-01",
                creado: "",
                usuario_creador: 0,
                actualizado: "",
                usuario_actualizado: 0,
                correlacion_id: 0,
                evaluacion_id: 0,
                maquina_variedad_id: 0,
                estado: 1,
                formato_defecto_id: "",
                correlacion: 0,
                defecto: 0,
                formato: 0,
                nombre_categoria_evaluacion: "",
                nombre_maquina: ""
            }


        },
        validadEntradaEdit(item) {

            //console.log(item);
            let itemVal = { ...item };

            this.modalView = true;
            this.creacion = false;
            this.stateProcess = "INICIO";
            this.hydraMaquina = itemVal
            this.getDefecto();

            this.rangeDate = `${itemVal.fecha_inicio} a ${itemVal.fecha_fin}`
            this.activo = itemVal.estado == 1
        },

        validadEntradaDelete(item, valstate) {

            //console.log(item);
            let itemVal = item;
            const me = this

            this.$swal.fire({
                title: valstate == 2 ? '¿Desea desactivar la tolerancia?' :
                    valstate == 1 ? '¿Desea activar la tolerancia?' :
                        '¿Desea eliminar la tolerancia?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-primary ml-1',
                    cancelButton: 'btn btn-outline-danger',
                },
                buttonsStyling: false,
                preConfirm: () => {

                    let maquina = {
                        id: item.id,
                        estado: valstate,
                        usuario_actualizado: item.usuario_actualizado
                    }
                    let url = `/hydra/hydratolerancia/delete/${maquina.id}`;

                    const config = {
                        method: 'put',
                        url: url,
                        data: maquina
                    }


                    return axiosIns(config)
                        .then(function (response) {
                            console.log(response);
                            let sms = response.data.message_user;
                            let str_status = "success"

                            me.listar();
                            return {
                                'sms': sms,
                                'str_status': str_status
                            }

                        })
                        .catch(function (error) {
                            console.log(error);
                            this.$swal.showValidationMessage(
                                `Error al desactivar registro`
                            )

                        });

                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal.fire(
                        '',
                        result.value.sms,
                        result.value.str_status
                    );
                }
            })



        },

        onsubmit(event) {
            event.preventDefault()
            if (this.creacion) {
                this.onSave();
            } else {
                this.onUpdate();

            }
        },

        async onUpdate() {
            let inicio = new Date(this.hydraMaquina.fecha_inicio)
            let fin = new Date(this.hydraMaquina.fecha_fin)

            if (inicio > fin) {
                this.$swal.fire(
                    'Error',
                    'La fecha de inicio debe ser menor que la mayor',
                    'error'
                );

                return;
            }

            let url = `/hydra/hydratolerancia/update/${this.hydraMaquina.id}`;

            const config = {
                method: 'put',
                url: url,
                data: this.hydraMaquina
            }


            this.stateProcess = "PROCESO";
            this.stateClose = true;


            try {
                let response = await axiosIns(config);
                if (response.status == 200) {
                    this.message = response.data.message_user;
                    if (response.data.code == 200 && response.data.data.length > 0) {
                        this.stateProcess = "FIN";
                    }
                }

            } catch (error) {

                this.message = error.response.data.message_user;
                this.stateProcess = "ERROR";
            }

            this.stateClose = false;

            this.listar();
        },

        async onSave() {



            if (this.hydraMaquina.maquina_variedad_id == 0 || this.hydraMaquina.correlacion_id == 0 || this.hydraMaquina.evaluacion_id == 0 || this.hydraMaquina.formato_defecto_id == 0) {

                this.$swal.fire(
                    'Error',
                    'Debe ingresar todos los campos obligatorios',
                    'error'
                );

                return;
            }

            let valor_min_ = 0;
            let valor_max_ = 0;

            try {
                valor_min_ = parseFloat(this.hydraMaquina.valor_min.toString().trim());
                valor_max_ = parseFloat(this.hydraMaquina.valor_max.toString().trim());
                if (valor_min_ >= valor_max_) {
                    this.$swal.fire(
                        'Error',
                        'El valor maximo debe ser mayor del minimo',
                        'error'
                    );
                    return;
                }
            } catch (error) {
                console.log(error);
                this.$swal.fire(
                    'Error',
                    'Debe ingresar un numero correcto',
                    'error'
                );
                return;
            }

            this.hydraMaquina.valor_max = valor_max_;
            this.hydraMaquina.valor_min = valor_min_;


            let inicio = new Date(this.hydraMaquina.fecha_inicio)
            let fin = new Date(this.hydraMaquina.fecha_fin)

            if (inicio > fin) {
                this.$swal.fire(
                    'Error',
                    'La fecha de inicio debe ser menor que la mayor',
                    'error'
                );

                return;
            }



            this.stateProcess = "PROCESO";
            this.stateClose = true;

            let user = JSON.parse(localStorage.getItem("userData"));
            let userID = user.id;// 3
            this.hydraMaquina.usuario_creador = userID;
            this.hydraMaquina.usuario_actualizado = userID;



            let url = '/hydra/hydratolerancia/create/'

            const config = {
                method: 'post',
                url: url,
                data: this.hydraMaquina
            }



            try {
                let response = await axiosIns(config);
                if (response.status == 200) {
                    this.message = response.data.message_user;
                    if (response.data.code == 200 && response.data.data.length > 0) {
                        this.stateProcess = "FIN";
                    }

                }

            } catch (error) {

                this.message = error.response.data.message_user;
                this.stateProcess = "ERROR";
            }


            this.stateClose = false;

            this.listar();
            if (this.creacion) {
                this.hydraMaquina = {
                    id: 0,
                    valor_min: 0,
                    valor_max: 0,
                    fecha_inicio: "2023-01-01",
                    fecha_fin: "2023-01-01",
                    creado: "",
                    usuario_creador: 0,
                    actualizado: "",
                    usuario_actualizado: 0,
                    correlacion_id: 0,
                    evaluacion_id: 0,
                    maquina_variedad_id: 0,
                    estado: 0,
                    formato_defecto_id: "",
                    correlacion: 0,
                    defecto: 0,
                    formato: 0,
                    nombre_categoria_evaluacion: "",
                    nombre_maquina: ""
                };
            }
        },


        cPaginacion(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        cPaginacionExcel(filteredItems) {
            this.totalRowsExcel = filteredItems.length
            this.currentPageExcel = 1
        },
        /*      cerrarModal() {
                 this.estadoModal = false
             }, */


    }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';


.handsontable td.currentRow,
.handsontable td.current {
    background: rgb(231, 243, 255)
}</style>
  